<template>
  <div class="login-wrap">
    <div class="ms-login">
      <div class="ms-title">
        <el-menu
          :default-active="currentTabComponent == 'Login' ? '1' : '2'"
          mode="horizontal"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
          class="ms-nav"
        >
          <el-menu-item index="1" @click="currentTabComponent = 'Login'"
            >登录</el-menu-item
          >
          <el-menu-item index="2" @click="currentTabComponent = 'Register'"
            >注册</el-menu-item
          >
        </el-menu>

        <component @registerFlag="registerSuccess()" v-bind:is="currentTabComponent"></component>
      </div>
    </div>
  </div>
</template>

<script>
import Register from './Register.vue'
import Login from './Login.vue'
export default {
  data: function () {
    return {
      currentTabComponent: 'Login',
      activeIndex: '1'
    }
  },
  components: {
    Login,
    Register
  },
  methods: {
    registerSuccess() {
      this.currentTabComponent = 'Login'
    }
  }
};
</script>

<style scoped>
.ms-nav {
  display: flex;
  justify-content: space-between;
}
.login-wrap {
  position: relative;
  width: 100%;
  /* height: 100%; */
  height: calc(100vh - 50px - 50px);
  background-image: url(../assets/img/login-bg.jpg);
  background-size: 100%;
}
.ms-title {
  width: 100%;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  color: rgb(10, 4, 4);
  border-bottom: 1px solid #ddd;
}
.ms-login {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 400px;
  margin: -190px 0 0 -175px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.3);
  overflow: hidden;
}
.ms-content {
  padding: 30px 30px;
}
.login-btn {
  text-align: center;
}
.login-btn button {
  width: 100%;
  height: 36px;
  margin-bottom: 10px;
}
.login-tips {
  font-size: 12px;
  line-height: 30px;
  color: #fff;
}
</style>